import { render, staticRenderFns } from "./ControlShutter.vue?vue&type=template&id=5041dcb5&scoped=true&"
import script from "./ControlShutter.vue?vue&type=script&lang=ts&"
export * from "./ControlShutter.vue?vue&type=script&lang=ts&"
import style0 from "./ControlShutter.vue?vue&type=style&index=0&id=5041dcb5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5041dcb5",
  null
  
)

export default component.exports